import React, { useEffect, useState } from "react";
import moment from "moment";
import defaultType1 from "../image/defaultType1.png";
import defaultType2 from "../image/defaultType2.png";
import close from "../image/close.png";
import arrow from "../image/arrow.png";
import openBower from "../image/open_brower.png"

const Detail = (props) => {
  let data = props.data;
  let {rn_app_info,isAndroid}=props.info
  const {content,title,publishPhoto,publishDate,viewNum,variableFields} = data;
const [showVideo,setShowVideo]=useState(false)
const [sourceUrl,setSourceUrl]=useState(false)
const [showMore,setShowMore]=useState(false)
const [isWeiXin,setIsWeiXin]=useState(false)

const HandleShowVideo = (e) => {
  let imgArr = e.getAttribute("alias-label");
  
  if (imgArr === "video") {
    let sourceUrl = e.getAttribute("source-url");
    setSourceUrl(sourceUrl)
    setShowVideo(true)
  }
};

useEffect(()=>{
  let div=document.querySelector(".content")
  let divContent=document.querySelector(".contentImg")
  let cssPath=document.querySelector("#csspath")
  let height=div.offsetHeight
  let imgTags = divContent.querySelectorAll("img");
  // 遍历每个 img 标签
  for (let i = 0; i < imgTags.length; i++) {
    const img = imgTags[i];
    // 移除 width 和 height 属性
    img.removeAttribute("width");
    img.removeAttribute("height");
    img.removeAttribute("style");
  }

  if (height && height > 1000) {
    div.style.height = "1000px";
    divContent.style.height = "940px";
    divContent.style.overflow = "hidden";
    setShowMore(true);
  }
  if (variableFields.formatId) {
    let host = window.location.origin;
    divContent.setAttribute("id", "vsb_content_" + variableFields.formatId);
    cssPath&&cssPath.setAttribute(
      "href",
      host +
        "/cm-sites/pms/cmSitesStatic/style/typeset/format" +
        variableFields.formatId +
        ".css"
    );
  }
},[])

const HandleShowAll=()=>{
  let div=document.querySelector(".content")
  let divContent=document.querySelector(".contentImg")
    div.style.height="auto"
    divContent.style.height="auto"
    // divContent.style.overflow="scroll"
    setShowMore(false)
}

  return (
    <div
      style={{ padding: 10}}
    >
      <div
        style={{
          fontSize: 20,
          color: "#222",
          fontWeight: "bold",
          marginBottom: 10,
          marginTop: 10,
          lineHeight: 1.5,
        }}
      >
        {title}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: 12,
          color: "#999",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={
              publishPhoto
                ? publishPhoto
                : variableFields && variableFields.publishType === 0
                ? defaultType1
                : defaultType2
            }
            style={{ width: 24, height: 24, verticalAlign: "middle" }}
            alt=""
          />
          <span style={{ margin: "0 10" }}>{variableFields.publishName}</span>
          <span>{publishDate && moment(publishDate).format("YYYY-MM-DD")}</span>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* <img src={readLogo} style={{ with: 10, height: 9 }} alt="" />
          <span style={{ marginLeft: 10 }}>{viewNum}</span> */}
        </div>
      </div>
      {content && (
        <div style={{ position: "relative" }} className="content">
          <div
            className={"contentImg"}
            onClick={(e) => {
              HandleShowVideo(e.target);
            }}
            dangerouslySetInnerHTML={{ __html: content }}
          />
          {
            showMore&&<div
            style={{
              width: "100%",
              height: rn_app_info&&rn_app_info.download_android_link?290:236,
              position: "absolute",
              bottom: "0px",
            }}
          >
            <div style={{width:"100%",height:236,display:"flex",alignItems:"flex-end", backgroundImage:"linear-gradient(-180deg,hsla(0,0%,100%,0) 6%,hsla(0,0%,100%,.48) 56%,hsla(0,0%,100%,.96) 92%)"}}>
              <div 
              className="zhankai"
              onClick={()=>HandleShowAll()}
              >
               <img src={arrow} style={{ with: 32, height: 32 }} alt="" />
              </div>
            </div>
            {
              rn_app_info&&rn_app_info.download_android_link&&
              <div
             onClick={() => {
              let ua = navigator.userAgent.toLowerCase();
            if (ua.indexOf("micromessenger") > -1) {
              setIsWeiXin(true)
            }else{
              window.location.href =rn_app_info.scheme_url+"?id="+data.id
              setTimeout(() => {
                let href = rn_app_info.download_ios_link;
                if (isAndroid) {
                  href = rn_app_info.download_android_link;
                }
  
                window.location.href = href;
              }, 1500);
            }
            }}
             style={{
                display: "flex",
                width: "100%",
                height: 44,
                fontSize: 18,
                backgroundColor: "#d11909",
                borderRadius: 5,
                boxSizing: "border-box",
                justifyContent: "center",
                alignItems: "center",
                color: "#fff",
                textDecoration: "none"
              }}
            >
              <span>打开APP阅读全文</span>
            </div>
            }
            
          </div>
          }
          
        </div>
      )}

      {showVideo && (
        <div
          style={{
            position: "fixed",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 99,
            backgroundColor: "#000",
          }}
        >
          <div style={{ width: "100%", height: "50px" }}>
            <img
              src={close}
              style={{ width: "40px", height: "40px", margin: "5px" }}
              onClick={() => setShowVideo(false)}
              alt=""
            />
          </div>
          <div
            style={{
              width: "100%",
              height: document.documentElement.clientHeight - 50,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <video
              src={sourceUrl}
              controls={true}
              autoPlay
              style={{ width: "100%" }}
            />
          </div>
        </div>
      )}

{
        isWeiXin&& <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          backgroundColor: "rgba(0,0,0,0.7)",
          zIndex: 2,
          textAlign: "right",
        }}
      >
        <img
          src={openBower}
          style={{ width: 250, marginTop: 10, marginRight: 20 }}
        />
      </div>
      }

      <style>
        {`
          .contentImg img{
                width:100% !important;
                display: flex !important;
                justify-content: center !important;
              }
              .zhankai{
                width:100%;
                height:40px;
                display:flex;
                justify-content:center;
                align-items:center;
                margin-bottom:10px;
                animation: jumpBoxHandler 1s infinite
              }
              @keyframes  jumpBoxHandler{
                0%{
                  transform:translate(0px,0px);
                }
                50%{
                  transform:translate(0px,10px);
                }
                100%{
                  transform:translate(0px,0px);
                }
              }
          `}
      </style>
    </div>
  );
};

export default Detail;
